{
	"FrameEffect_null": "null",
	"FrameEffect_enchantment": "enchantment",
	"FrameEffect_etched": "etched",
	"FrameEffect_extendedart": "extendedart",
	"FrameEffect_fullart": "fullart",
	"FrameEffect_inverted": "inverted",
	"FrameEffect_legendary": "legendary",
	"FrameEffect_lesson": "lesson",
	"FrameEffect_showcase": "showcase",
	"FrameEffect_snow": "snow"
}